import {useSelector} from 'react-redux';
import {Redirect, Route, Switch as RouterSwitch} from 'react-router-dom';

import PrivateRoute from '../../../gates/PrivateRoute';
import authenticationService from '../../../services/authentication/AuthenticationService';

import Details from '../Details';
import Subscription from '../Subscription';
import MandatesList from '../MandatesList';
import MandateDetails from '../MandateDetails';
import Users from '../Users';

function Switch() {
  const isManager = authenticationService.roles().isManager();
  const isDepositor = useSelector(state => state.organisation.depositor);

  return (
    <RouterSwitch>
      <Redirect
        from="/organisation"
        exact
        to="/organisation/details"
      />
      <Route
        exact
        path="/organisation/details"
        component={Details}
      />
      <Route
        exact
        path="/organisation/users"
        component={Users}
      />
      <PrivateRoute
        exact
        path="/organisation/subscription"
        component={Subscription}
        canAccess={isManager}
      />
      <PrivateRoute
        exact
        path={'/organisation/collection-mandates/:mandateId([0-9]+)'}
        canAccess={isManager && isDepositor}
        render={() => <MandateDetails isCollectionMandate={true}/>}
      />
      <PrivateRoute
        path={'/organisation/collection-mandates'}
        canAccess={isManager && isDepositor}
        render={() => <MandatesList isCollectionMandate={true}/>}
      />
      <PrivateRoute
        exact
        path={'/organisation/broadcast-mandates/:mandateId([0-9]+)'}
        canAccess={isManager && isDepositor}
        render={() => <MandateDetails isCollectionMandate={false}/>}
      />
      <PrivateRoute
        path={'/organisation/broadcast-mandates'}
        canAccess={isManager && isDepositor}
        render={() => <MandatesList isCollectionMandate={false}/>}
      />
    </RouterSwitch>
  );
}

export default Switch;
